
const StaticText = (fieldRenderProps) => {
    const { value } = fieldRenderProps;
    return (
        <div className="k-form-field">
            <div className="k-form-field-wrap">
                <span>{ value }</span>
            </div>
        </div>
    );
};

export default StaticText;
